import { api } from "./api";

export interface BenchmarkDto {
  id: string;
  symbol: string;
  displayName: string;
  provider: string;
  currency: string | null;
  isActiveForKpi: boolean;
  initialBackfillCompleted: boolean;
  initialBackfillFailedReason: string | null;
  quoteCount: number;
  latestQuoteAsOf: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface BenchmarkSettings {
  dailyRefreshHourUtc: number;
  updatedAt: string;
}

export const benchmarksApi = {
  list: () => api<BenchmarkDto[]>("/benchmarks"),
  get: (id: string) => api<BenchmarkDto>(`/benchmarks/${id}`),
  create: (input: { symbol: string; displayName: string; provider: "YAHOO" }) =>
    api<BenchmarkDto>("/benchmarks", { method: "POST", body: input }),
  update: (id: string, input: { displayName?: string; isActiveForKpi?: boolean }) =>
    api<BenchmarkDto>(`/benchmarks/${id}`, { method: "PATCH", body: input }),
  delete: (id: string) => api(`/benchmarks/${id}`, { method: "DELETE" }),
  backfill: (id: string, input?: { fromDate?: string; toDate?: string }) =>
    api<{ status: string; quotesCreated?: number }>(`/benchmarks/${id}/backfill`, {
      method: "POST",
      body: input ?? {},
    }),
  refreshAll: () =>
    api<{ processed: number; succeeded: number; failed: number }>("/benchmarks/refresh-all", {
      method: "POST",
    }),
  getSettings: () => api<BenchmarkSettings>("/benchmark-settings"),
  updateSettings: (input: { dailyRefreshHourUtc: number }) =>
    api<BenchmarkSettings>("/benchmark-settings", {
      method: "PATCH",
      body: input,
    }),
};
